// extracted by mini-css-extract-plugin
export default {"item":"TaskItem_item__r+kf3","link":"TaskItem_link__G+sx5"};